import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./sidebar.scss";
import Navbar from "../Navbar/Navbar";
import Logo from "../../assets/mundo.svg";
import {
  BOLETAS_LINK,
  MUNDO_GO_LINK,
  PAGOS_LINK,
  REAGENDAR_VISITA_LINK,
  REALIZAR_SOLICITUD_LINK,
  REGISTRO_ACTIVIDAD_LINK,
  RECLAMOS_LINK,
  SOLICITUDES_COMERCIALES_LINK,
  SOLICITUDES_TECNICAS_LINK,
  SUGERENCIAS_LINK,
  PLAN_LINK,
  CONFIGURACION,
  DISPOSITIVOS,
  CAMBIO_SIM_LINK,
} from "../../helpers/enlacesSideBar";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import WifiRoundedIcon from "@mui/icons-material/WifiRounded";
import { useLocation } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useUsuario } from "../../context/usuarioContext";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import HomeIcon from "@mui/icons-material/Home";
import { motion, AnimatePresence } from "framer-motion";
import "./modalUsuario.scss";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import SimCardIcon from '@mui/icons-material/SimCard';

const Sidebar = ({
  showMenu,
  setShowMenu,
  selectedItem,
  setSelectedItem,
  selectedItemNoExpanded,
  setSelectedItemNoExpanded,
  subSelectedItem,
  setSubSelectedItem,
  navSelectedItem,
  setNavSelectedItem,
  expandedItems,
  setExpandedItems,
  contratos,
}) => {
  const { usuario, contratoSeleccionado, setContratoSeleccionado } =
    useUsuario();
  const [openModalUsuario, setOpenModalUsuario] = useState(false);

  const location = useLocation();

  const handleItemClick = (item) => {
    if (item === selectedItem) {
      setSelectedItem("");
      setExpandedItems({
        boleta: false,
        solicitud: false,
      });
    } else {
      setSelectedItem(item);
      setExpandedItems((prevState) => ({
        boleta: item === "boleta" ? true : false,
        solicitud: item === "solicitud" ? true : false,
        conexion: item === "conexion" ? true : false,
      }));
    }

    setNavSelectedItem("");
  };

  const handleItemNoExpanded = (itemNoExpanded) => {
    if (itemNoExpanded.startsWith("/")) {
      itemNoExpanded = itemNoExpanded.slice(1);
    }

    setExpandedItems({
      boleta: false,
      solicitud: false,
      conexion: false,
    });
    setSelectedItem("");
    setNavSelectedItem("");
    setSelectedItemNoExpanded(itemNoExpanded);
    handleMenuToggle();
  };

  const handleSubItemClick = (subItem) => {
    setSubSelectedItem(subItem);
    handleMenuToggle();
  };

  const handleMenuToggle = () => {
    if (window.innerWidth <= 767) {
      setShowMenu((prevShowMenu) => !prevShowMenu);
    }
  };

  useEffect(() => {
    const boton = document.getElementById("cari_button");
    const cari_2 = document.getElementById("cari_webchat_container");
    if (boton || cari_2) {
      boton.style.display = showMenu ? "none" : "block";
      cari_2.style.display = "none";
    }
  }, [showMenu]);

  const handleModalUsuario = () => {
    setOpenModalUsuario(!openModalUsuario);
  };

  useEffect(() => {
    const urlParts = location.pathname.split("/");
    const lastUrlPart = urlParts[urlParts.length - 1];

    if (lastUrlPart == "boletas" || lastUrlPart == "pagos") {
      setSelectedItem("boleta");
      setSelectedItemNoExpanded("");
      setSubSelectedItem(lastUrlPart);
    }

    if (
      lastUrlPart == "realizar-solicitud" ||
      lastUrlPart == "solicitudes-tecnicas" ||
      lastUrlPart == "solicitudes-comerciales" ||
      lastUrlPart == "reagendar-visita" ||
      lastUrlPart == "reclamos" ||
      lastUrlPart == "registro-actividad"
    ) {
      setSelectedItem("solicitud");
      setSelectedItemNoExpanded("");
      setSubSelectedItem(lastUrlPart);
    }

    if (
      lastUrlPart == "resume" ||
      lastUrlPart == "mundo-go" ||
      lastUrlPart == "sugerencias" ||
      lastUrlPart == "mi-plan" ||
      lastUrlPart == "beneficios"||
      lastUrlPart == "sim"
    ) {
      setSelectedItem("");
      setSubSelectedItem("");
      setSelectedItemNoExpanded(lastUrlPart);
    }

    if (lastUrlPart == "") {
      setSelectedItemNoExpanded("resume");
      setSubSelectedItem("");
    }

    if (lastUrlPart == "configuracion" || lastUrlPart == "dispositivos") {
      setSelectedItem("conexion");
      setSelectedItemNoExpanded("");
      setSubSelectedItem(lastUrlPart);
    }
  }, [location]);

  useEffect(() => {
    const expandedStates = {
      boleta: { boleta: true, plan: false, solicitud: false, conexion: false },
      Plan: { boleta: false, plan: true, solicitud: false, conexion: false },
      solicitud: {
        boleta: false,
        plan: false,
        solicitud: true,
        conexion: false,
      },
      conexion: {
        boleta: false,
        plan: false,
        solicitud: false,
        conexion: true,
      },
    };

    setExpandedItems(
      expandedStates[selectedItem] || {
        boleta: false,
        plan: false,
        solicitud: false,
        conexion: false,
      }
    );
  }, [selectedItem]);

  const handleContratoSelected = (contratoSelect) => {
    setContratoSeleccionado(contratoSelect);
    setShowMenu(false);
    handleModalUsuario();
  };

  return (
    <>
      <div className="sidebar__header">
        <button
          className={`menu-toggle ${showMenu ? "show-menu" : ""}`}
          onClick={handleMenuToggle}
        >
          {showMenu ? <p>⨯</p> : <p>≡</p>}
        </button>
        <div className="logo">
          <Logo className="logo__image" />
          {/* <img className="logo__image" src={Logo} /> */}
        </div>
      </div>

      <ul className="menu">
        <li
          className="menu__item--usuario"
          onClick={() => handleModalUsuario()}
        >
          {contratoSeleccionado && (
            <div className="menu__contenedor">
              <h2 className="menu__item--usuario__nombre">{`${
                usuario?.Nombres ?? ""
              } ${usuario?.ApPaterno ?? ""} ${usuario?.ApMaterno ?? ""}`}</h2>
              <div className="plan">
                <h3 className="plan__nombre">
                  {contratoSeleccionado?.unidad_negocio == 1
                    ? "Plan Móvil"
                    : "Plan Hogar"}
                </h3>
                <div className="plan__direccion">
                  <h2 className="plan__direccion__nombre">
                    {contratoSeleccionado?.unidad_negocio == 1
                      ? contratoSeleccionado?.linea
                      : `${
                          contratoSeleccionado?.hp?.hp_calle
                            ? contratoSeleccionado?.hp?.hp_calle.toLowerCase()
                            : ""
                        } ${
                          contratoSeleccionado?.hp?.hp_numero
                            ? contratoSeleccionado?.hp?.hp_numero.toLowerCase()
                            : ""
                        }`}
                  </h2>
                  <ExpandMoreIcon />
                </div>
              </div>
            </div>
          )}
          <AnimatePresence>
            {openModalUsuario && (
              <>
                <div
                  className="modal-overlay"
                  onClick={() => handleModalUsuario()}
                />
                <div className="modal-content">
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                      transition: { duration: 0.3, type: "tween" },
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                      transition: { duration: 0, type: "tween" },
                    }}
                    style={{
                      overflow: "hidden",
                      maxHeight: "500px",
                      borderRadius: "0px 0px 10px 10px",
                    }}
                  >
                    <ul
                      className="modal-list"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      {contratoSeleccionado &&
                        contratos.map((contrato) => (
                          <li
                            key={contrato?.id_contrato}
                            className={`modal-item${
                              contrato?.id_contrato ===
                              contratoSeleccionado?.id_contrato
                                ? " selected"
                                : ""
                            }`}
                          >
                            <div
                              className="descripcion"
                              onClick={() => handleContratoSelected(contrato)}
                            >
                              <h2
                                className={`descripcion__item__nombre${
                                  contrato?.id_contrato ===
                                  contratoSeleccionado?.id_contrato
                                    ? " selected"
                                    : ""
                                }`}
                              >
                                {contrato?.unidad_negocio === 1
                                  ? "Plan Móvil"
                                  : "Plan Hogar"}
                              </h2>
                              <h2
                                className={`descripcion__item__detalle${
                                  contrato.id_contrato ===
                                  contratoSeleccionado.id_contrato
                                    ? " selected"
                                    : ""
                                }`}
                              >
                                {contrato.unidad_negocio === 1
                                  ? contrato.linea
                                  : `${
                                      contrato.hp?.hp_calle?.toLowerCase() ?? ""
                                    } ${
                                      contrato.hp?.hp_numero?.toLowerCase() ??
                                      ""
                                    }`}
                              </h2>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </motion.div>
                </div>
              </>
            )}
          </AnimatePresence>
        </li>

        <div className="menu__items">
          <li
            className={`menu__item ${
              selectedItemNoExpanded === "resume" ? "selected" : ""
            }`}
          >
            <Link
              onClick={() => handleItemNoExpanded("resume")}
              to="/"
              className="menu_item_no_expanded"
            >
              <AssessmentOutlinedIcon
                style={{ display: "inline-block", verticalAlign: "middle" }}
              />
              <h3 className="menu__item__seccion__nombre">Resumen</h3>
            </Link>
          </li>

          {contratos && contratos.length > 0 && (
            <li
              className={`menu__item ${
                expandedItems.boleta ||
                subSelectedItem === "boletas" ||
                subSelectedItem === "pagos"
                  ? "expanded selected"
                  : ""
              }`}
            >
              <span
                className="menu__item-label"
                onClick={() => handleItemClick("boleta")}
              >
                <div className="menu__item__seccion">
                  <ArticleOutlinedIcon
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  />
                  <div className="container__nombre__icono">
                    <h3 className="menu__item__seccion__nombre">
                      Boletas y pagos
                    </h3>
                    <div className="menu__item__seccion__icono">
                      {expandedItems.boleta ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </div>
                  </div>
                </div>
              </span>
              <AnimatePresence>
                {expandedItems.boleta && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                      transition: { duration: 0.3 },
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                      transition: { duration: 0.3 },
                    }}
                  >
                    <ul className="submenu">
                      <li
                        className={`submenu__item ${
                          subSelectedItem === "boletas" ? "selected" : ""
                        }`}
                      >
                        <Link
                          onClick={() => handleSubItemClick("boletas")}
                          to={BOLETAS_LINK}
                        >
                          Boletas
                        </Link>
                      </li>
                      <li
                        className={`submenu__item ${
                          subSelectedItem === "pagos" ? "selected" : ""
                        }`}
                      >
                        <Link
                          onClick={() => handleSubItemClick("pagos")}
                          to={PAGOS_LINK}
                        >
                          Pagos
                        </Link>
                      </li>
                    </ul>
                  </motion.div>
                )}
              </AnimatePresence>
            </li>
          )}

          {contratos && contratos.length > 0 && (
            <li
              className={`menu__item ${
                selectedItemNoExpanded === "mi-plan" ? "selected" : ""
              }`}
            >
              <Link
                onClick={() => handleItemNoExpanded("mi-plan")}
                to={PLAN_LINK}
                className="menu_item_no_expanded"
              >
                {contratoSeleccionado?.unidad_negocio == 1 ? (
                  <PhoneAndroidIcon
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  />
                ) : (
                  <HomeIcon
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  />
                )}
                <h3 className="menu__item__seccion__nombre">Mi plan</h3>
              </Link>
            </li>
          )}
          <li
            className={`menu__item ${
              expandedItems.solicitud ||
              subSelectedItem === "solicitudes-tecnicas" ||
              subSelectedItem === "reagendar-visita" ||
              subSelectedItem === "registro-actividad" ||
              subSelectedItem === "reclamos"
                ? "expanded selected"
                : ""
            }`}
          >
            <span
              className="menu__item-label"
              onClick={() => handleItemClick("solicitud")}
            >
              <div className="menu__item__seccion">
                <AssignmentOutlinedIcon
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                />
                <div className="container__nombre__icono">
                  <h3 className="menu__item__seccion__nombre">
                    Mis solicitudes
                  </h3>
                  <div className="menu__item__seccion__icono">
                    {expandedItems.solicitud ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </div>
                </div>
              </div>
            </span>
            <AnimatePresence>
              {expandedItems.solicitud && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{
                    height: "auto",
                    opacity: 1,
                    transition: { duration: 0.3 },
                  }}
                  exit={{
                    height: 0,
                    opacity: 0,
                    transition: { duration: 0.3 },
                  }}
                >
                  <ul className="submenu">
                    <li
                      className={`submenu__item ${
                        subSelectedItem === "solicitudes-tecnicas"
                          ? "selected"
                          : ""
                      }`}
                    >
                      <Link
                        onClick={() =>
                          handleSubItemClick("solicitudes-tecnicas")
                        }
                        to={SOLICITUDES_TECNICAS_LINK}
                      >
                        Historial de solicitudes
                      </Link>
                    </li>
                    <li
                      className={`submenu__item ${
                        subSelectedItem === "reagendar-visita" ? "selected" : ""
                      }`}
                    >
                      <Link
                        onClick={() => handleSubItemClick("reagendar-visita")}
                        to={REAGENDAR_VISITA_LINK}
                      >
                        Mis visitas técnicas
                      </Link>
                    </li>
                    <li
                      className={`submenu__item ${
                        subSelectedItem === "registro-actividad"
                          ? "selected"
                          : ""
                      }`}
                    >
                      <Link
                        onClick={() => handleSubItemClick("registro-actividad")}
                        to={REGISTRO_ACTIVIDAD_LINK}
                      >
                        Registro de actividad
                      </Link>
                    </li>
                    <li
                      className={`submenu__item ${
                        subSelectedItem === "reclamos" ? "selected" : ""
                      }`}
                    >
                      <Link
                        onClick={() => handleSubItemClick("reclamos")}
                        to={RECLAMOS_LINK}
                      >
                        Reclamos
                      </Link>
                    </li>
                  </ul>
                </motion.div>
              )}
            </AnimatePresence>
          </li>
          {contratos && contratos.length > 0 && contratoSeleccionado.configurar_wifi && (<li
            className={`menu__item ${
              expandedItems.conexion ||
              subSelectedItem === "conexion-configuracion" ||
              subSelectedItem === "conexion-dispositivo"
                ? "expanded selected"
                : ""
            }`}
          >
            <span
              className="menu__item-label"
              onClick={() => handleItemClick("conexion")}
            >
              <div className="menu__item__seccion">
                <WifiRoundedIcon
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                />
                <div className="container__nombre__icono">
                  <h3 className="menu__item__seccion__nombre">Ajustes de WiFi</h3>
                  <div className="menu__item__seccion__icono">
                    {expandedItems.conexion ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </div>
                </div>
              </div>
            </span>
            <AnimatePresence>
              {expandedItems.conexion && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{
                    height: "auto",
                    opacity: 1,
                    transition: { duration: 0.3 },
                  }}
                  exit={{
                    height: 0,
                    opacity: 0,
                    transition: { duration: 0.3 },
                  }}
                >
                  <ul className="submenu">
                    <li
                      className={`submenu__item ${
                        subSelectedItem === "configuracion"
                          ? "selected"
                          : ""
                      }`}
                    >
                      <Link
                        onClick={() =>
                          handleSubItemClick("configuracion")
                        }
                        to={CONFIGURACION}
                      >
                        Configuraciones
                      </Link>
                    </li>
                    
                  </ul>
                </motion.div>
              )}
            </AnimatePresence>
          </li>)}
          <li
            className={`menu__item ${
              selectedItemNoExpanded === "beneficios" ? "selected" : ""
            }`}
          >
            <Link
              onClick={() => handleItemNoExpanded("beneficios")}
              to="/beneficios"
              className="menu_item_no_expanded"
            >
              <LoyaltyIcon
                style={{ display: "inline-block", verticalAlign: "middle" }}
              />
              <h3 className="menu__item__seccion__nombre">Beneficios</h3>
            </Link>
          </li>
          {contratoSeleccionado?.unidad_negocio == 1 && (
          <li
              className={`menu__item ${
                selectedItemNoExpanded === "cambio-sim" 
                  ? "selected"
                  : ""
              }`}
            >
              <Link
                onClick={() =>
                  handleItemNoExpanded("cambio-sim"
                  )
                }
                to={CAMBIO_SIM_LINK}
                className="menu_item_no_expanded"
              >
                

                  <SimCardIcon
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  />


                <h3 className="menu__item__seccion__nombre">SIM</h3>
              </Link>
            </li>
            )}
        </div>
      </ul>

      {showMenu && (
        <div className="navbar--mobile">
          <Navbar
            setShowMenu={setShowMenu}
            navSelectedItem={navSelectedItem}
            setNavSelectedItem={setNavSelectedItem}
            setSelectedItem={setSelectedItem}
            setSelectedItemNoExpanded={setSelectedItemNoExpanded}
            setSubSelectedItem={setSubSelectedItem}
            expandedItems={expandedItems}
            setExpandedItems={setExpandedItems}
            contratos={contratos}
          />
        </div>
      )}
    </>
  );
};

export default Sidebar;
